import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import "./styles.css";
import CacheManager from "./utility/CacheManager";
import EndPointInfo from "./utility/Endpoints";

import { AppConfigProvider } from "./providers/AppConfigProvider";
import useNavigatorOnLine from "./hooks/useNavigatorOnLine";
import { getCCPMetaData } from "./services/ccpCommonService";
import { buildEndPointsForCCP, routingProfiles, agentLdapCheck } from "./utility/util";

// Redux and providers
// import { Provider } from "react-redux";
// import { store } from "./redux/store";
// import SocketProvider from "./providers/SocketProvider";

const appLoadingContainer = document.getElementById("CCP-Loading");
const appLoadedContainer = document.getElementById("CCP-Loaded");
const loginMessage = document.getElementById("CCP-Login-Message");
const loginLink = document.getElementById("CCP-Login-Link");
const appRoot = document.getElementById("CCP-Modules");
const ccpRoot = document.getElementById("CCP");

const openLoginWindow = (_LOGIN) =>
  window.open(
    _LOGIN ? _LOGIN :EndPointInfo.Connect.login,
    "CCP-Login",
    "titlebar=0, width=800, height=800, top=10, left=10, menubar=0"
  );

// eslint-disable-next-line no-param-reassign
const hideElement = (element) => {
  element.style.display = "none";
};
// eslint-disable-next-line no-param-reassign
const showElement = (element) => {
  element.style.display = "block";
};
// eslint-disable-next-line no-param-reassign
const displayElement = (element) => {
  element.style.visibility = "visible";
};
let clientType = "";
const initCCP = (_CCP) => {
  window.connect.core.initCCP(ccpRoot, {
    ccpUrl: _CCP ? _CCP : EndPointInfo.Connect.ccp,
    loginPopup: false,
    region: "us-ease-1",
    softphone: {
      allowFramedSoftphone: true,
    },
  });
};

const initializeApp = async () => {
  let ccpMetaDataRes = await getCCPMetaData();
  console.log("ccpMetaDataRes", ccpMetaDataRes);

  const buildEndPoints = buildEndPointsForCCP(ccpMetaDataRes)
  console.log("buildEndPoints", buildEndPoints)
    
  CacheManager();
  initCCP(buildEndPoints.ccp);

  let loginWindow;
  const events = window.connect.core.getEventBus();
  console.log("events", window.connect);
  // User not logged in, prompt for login
  const ackTimeouts = events.subscribe(
    window.connect.EventType.ACK_TIMEOUT,
    () => {
      CacheManager();
      loginWindow = openLoginWindow(buildEndPoints.login);

      displayElement(loginMessage);
      loginLink.onclick = () => {
        loginWindow = openLoginWindow(buildEndPoints.login);
      };
    }
  );

  //  window.connect.agent().onRefresh(function(contact){

  //  }).unsubscribe();
  // Wait for agent context before rendering CCP
  const agents = window.connect.agent((agent) => {
    console.log("Release 7.0");
    
    const agentLdap = agent.getConfiguration().username;
    const routingProfile = agent.getConfiguration().routingProfile;
    console.log("routingProfile >>>", routingProfile)
    const contactsList = agent.getContacts();
    console.log("contactsList", contactsList);

    if (loginWindow) {
      loginWindow.close();
    }

    ackTimeouts.unsubscribe();
    agents.unsubscribe();

    // upgrade to React 18 version
    function AppWithCallbackAfterRender() {
      const isOnline = useNavigatorOnLine();
      useEffect(() => {
        hideElement(appLoadingContainer);
        showElement(appLoadedContainer);
      }, []);
// Custom-Rag
const projectStage = process.env.REACT_APP_PROJECT_STAGE ? process.env.REACT_APP_PROJECT_STAGE : 'qa';
console.log("projectStageFromIndex", process.env.REACT_APP_PROJECT_STAGE, projectStage)
const ENV_ENUM = {
    DEV : 'dev',
    QA  : 'qa',
    PROD: 'prod'
}
const routingProfileToCheck = (projectStage === ENV_ENUM.PROD) ? routingProfiles.routingProfilesProd : routingProfiles.routingProfilesDev

const ldapsToCheck = (projectStage === ENV_ENUM.PROD) ? agentLdapCheck.agentLdapCheckProd : agentLdapCheck.agentLdapCheckDev
    
const routingValue = (routingProfileToCheck.includes(routingProfile.name) || ldapsToCheck.includes(agentLdap)) ? "true" : "false";


      return (
        <>
        <AppConfigProvider
          routingValue={routingValue}
          agentLdap={agentLdap}
          routingProfile={routingProfile}
          contactsList = {contactsList}
          isAppOnline = {isOnline}
        >
          <App clientType={clientType || ""} />
        </AppConfigProvider>
        </>
  );
    }

    const root = createRoot(appRoot); // createRoot(container!) if you use TypeScript
    root.render(<AppWithCallbackAfterRender />);
  });

  // User logged out, reload the page
  events.subscribe(window.connect.EventType.TERMINATED, () => {
    // eslint-disable-next-line no-restricted-globals
    location.reload(true);
  });

  // Auth error, reload the page
  events.subscribe(window.connect.EventType.AUTH_FAIL, () => {
    // eslint-disable-next-line no-restricted-globals
    location.reload(true);
  });
};

initializeApp();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
